module.exports = "\r\n<app-register></app-register>\r\n"